import type { TOrganization } from '@src/shared/types/organization';
import type { TUser } from '@src/shared/types/user';
import type { TBaseQuery } from '@shared/types/base-query';
import type { TPermission } from '@shared/types/permission';

import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export type TPartnerRole = {
  id: number;
  permissions: TPermission[];
  created_at: string;
  updated_at: string;
  name: string;
  description: string;
  is_default: boolean;
  organization: number;
};

export type TPartner = {
  id: number;
  organization: TOrganization;
  user: TUser;
  is_active: boolean;
  date_of_birth: string;
  marital_status: string;
  gender: string;
  nationality: string;
  role: TPartnerRole;
  job_title: string;
  department: string;
  hire_date: string;
  work_type: string;
  work_location: string;
  is_owner: boolean;
  first_name: string;
  last_name: string;
  avatar: string;
  language: string;
  timezone: string;
  whatsapp_number: string;
  type: string;
  no_of_leads: number;
  no_of_participants: number;
  programs: Array<{
    id: number;
    name: string;
  }>;
  company_name: string;
};

export type TPartnerQuery = {
  is_active?: boolean;
  organization?: number;
  program?: number[];
  user?: number[];
} & TBaseQuery;

export type TPartnerBody = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  avatar?: File | string | null;
  role: number;
  company_name: string;
  programs?: number[];
  is_active?: boolean;
};

export const partnersApi = createCrudService<
  TPartner,
  TPartnerQuery,
  TPartnerBody
>({
  queryKey: [QUERY_KEYS.getPartners],
  url: 'partners',
  factory: {
    create: {
      requestOptions: () => {
        return {
          url: 'partners/invite/',
          method: 'POST',
        };
      },
    },
  },
});

export const activatePartnerApi = createCrudService<
  {detail: string},
  TPartnerQuery,
  { ids: number[] }
>({
  queryKey: [QUERY_KEYS.getPartners],
  url: 'partners/bulk-activate/',
  factory: {
    create: {
      requestOptions: () => {
        return {
          url: 'partners/bulk-activate/',
          method: 'PATCH',
        };
      },
    },
  }
});

export const deactivatePartnerApi = createCrudService<
  {detail: string},
  TPartnerQuery,
  { ids: number[] }
>({
  queryKey: [QUERY_KEYS.getPartners],
  url: 'partners/bulk-deactivate/',
  factory: {
    create: {
      requestOptions: () => {
        return {
          url: 'partners/bulk-deactivate/',
          method: 'PATCH',
        };
      },
    },
  }
});